import {
  CheckCircleFilled,
  CloseOutlined,
  DeleteOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  ConfigProvider,
  DatePicker,
  Pagination,
  Radio,
  RadioChangeEvent,
  Select,
  Switch,
  Tabs,
  TabsProps,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  backRemovedPost,
  changePostPage,
  feedFilterClear,
  feedFilterSubmit,
  fetchPosts,
  fetchStopPost,
  removeRefPost,
} from "../redux/actions";
import FeedStatistics from "./feed-statistics/feed-statistics";
import IconChecked from "./icons/checked";
import IconUndo from "./icons/undo";
import Post from "./post";
import locale from "antd/es/date-picker/locale/ru_RU";
import { useSelector } from "react-redux";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import {
  getPostCount,
  getPostIsLoading,
  getPostList,
  getPostPageNumber,
  getPostPageSize,
  getReferences,
  getReferencesFilter,
  getThread,
} from "../redux/selectors";
import { useAppDispatch } from "../redux/store/hooks";
import { useNavigate } from "react-router-dom";
import TonalStatistic from "./TonalStatisticSmall";
import TonalStatisticSmall from "./TonalStatisticSuperSmall";

const PostsList: React.FC = () => {
  const [value, setValue] = useState("month");
  const { RangePicker } = DatePicker;
  const feedFilter = useSelector(getFeedFilter);
  const [tonality, setTonality] = useState(feedFilter.tonal);
  const [tonal, setTonal] = useState();
  const [repostOption, setRepostOption] = useState(feedFilter.repostoption);
  const [friendly, setFriendly] = useState(feedFilter.friendly);
  const [sorting, setSorting] = useState(feedFilter.sort);
  const [switchValue, setSwitchValue] = useState(false);
  const [checkedPosts, setCheckedPosts] = useState([]);
  const current = window.location.pathname.split("/")[2];
  const [tab, setTab] = useState("post");
  const referencesFilter = useSelector(getReferencesFilter);
  const references = useSelector(getReferences);
  const [dateString, setDateString] = useState([
    feedFilter.from,
    feedFilter.to,
  ]);
  const isLoading = useSelector(getPostIsLoading);
  const postList = useSelector(getPostList);
  const postCount = useSelector(getPostCount);
  const pageNumber = useSelector(getPostPageNumber);
  const pageSize = useSelector(getPostPageSize);
  const options = [
    { label: " Другое", value: "period" },
    { label: "Сегодня", value: "today" },
    { label: "7д", value: "week" },
    { label: "1м", value: "month" },
  ];

  const thread = useSelector(getThread);

  let netOptions: any = [];
  if (thread?.networks?.includes(1))
    netOptions.push({ value: "vk", label: "ВКонтакте" });
  if (thread?.networks?.includes(2))
    netOptions.push({ value: "tw", label: "Twitter" });
  if (thread?.networks?.includes(3))
    netOptions.push({ value: "fb", label: "Facebook" });
  if (thread?.networks?.includes(5))
    netOptions.push({ value: "tg", label: "Telegram" });
  if (thread?.networks?.includes(7))
    netOptions.push({ value: "ig", label: "Instagram" });
  if (thread?.networks?.includes(8))
    netOptions.push({ value: "yt", label: "Youtube" });
  if (thread?.networks?.includes(10))
    netOptions.push({ value: "ok", label: "Одноклассники" });
  if (thread?.networks?.includes(11))
    netOptions.push({ value: "dz", label: "Дзен" });
  if (thread?.networks?.includes(4))
    netOptions.push({ value: "smi", label: "СМИ" });

  const [source, setSource] = useState({
    smi: feedFilter.smi,
    vk: feedFilter.vk,
    tw: feedFilter.tw,
    ig: feedFilter.ig,
    tg: feedFilter.tg,
    yt: feedFilter.yt,
    dz: feedFilter.dz,
    ok: feedFilter.ok,
    fb: feedFilter.fb,
  });

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const start = new Date();
    start.setDate(start.getDate() - 29);
    setDateString([
      start.toJSON().split("T")[0],
      new Date().toJSON().split("T")[0],
    ]);
  }, []);

  useEffect(() => {
    dispatch(
      feedFilterSubmit({
        from: dateString[0].slice(0, 10) + " 00:00:00",
        to: dateString[1].slice(0, 10) + " 23:59:59",
        smi: thread?.networks?.includes(4) && source.smi,
        vk: thread?.networks?.includes(1) && source.vk,
        tw: thread?.networks?.includes(2) && source.tw,
        fb: thread?.networks?.includes(3) && source.fb,
        ig: thread?.networks?.includes(7) && source.ig,
        tg: thread?.networks?.includes(5) && source.tg,
        yt: thread?.networks?.includes(8) && source.yt,
        dz: thread?.networks?.includes(11) && source.dz,
        ok: thread?.networks?.includes(10) && source.ok,
        tonal: tonality,
        friendly: friendly,
        sorting: sorting,
        profile_id: [],
        repostoption: repostOption,
      })
    );
    if (thread && tab == "post") dispatch(fetchPosts());
    if (thread && tab == "stop") dispatch(fetchStopPost());
  }, [source, dateString, sorting, tonality, thread, repostOption, tab]);


  const onCheck: any = (target: any, post: any) => {
    let checkedPostsArr: any = [...checkedPosts];
    if (target == true) checkedPostsArr.push(post);
    else if (target == false) {
      const filteredNumbers = checkedPostsArr.filter(
        (it: any) => it.id !== post.id
      );
      checkedPostsArr = filteredNumbers;
    }
    setCheckedPosts(checkedPostsArr);
  };

  const selectAll = () => {
    let checkedPostsArr: any = [];
    postList?.forEach((post) => checkedPostsArr.push(post));
    setCheckedPosts(checkedPostsArr);
  };

  const deleteAll = () => {
    if (tab == "post")
      checkedPosts?.forEach((post: any) => {
        dispatch(
          removeRefPost(post.id, post.ownerId, post.network.id, references[0])
        );
        setCheckedPosts([]);
      });
    if (tab == "stop")
      checkedPosts?.forEach((post: any) => {
        dispatch(
          backRemovedPost(post.id, post.ownerId, post.network.id, references[0])
        );
        setCheckedPosts([]);
        //dispatch(removeThreadPost(post.id, post.ownerId, post.network.id))
      });
    if (thread && tab == "post") dispatch(fetchPosts());
    if (thread && tab == "stop")
      setTimeout(() => dispatch(fetchStopPost()), 1000);
  };

  const changeTonal = (value: any) => {
    console.log(value);
    setTonal(value);
    //if (thread && tab == "post") dispatch(fetchPosts());
    //if (thread && tab == "stop") dispatch(fetchStopPost());
  };

  return (
    <div>
      <div className="white-block">
      <div className="flex-end">
          <div className="grey">
            <h1 className="">Информационная аналитика</h1>
          </div>
          <Button onClick={() => navigate(`/media`)}>Все сигналы и упоминания</Button>
        </div>
        <TonalStatisticSmall />
        {tab == "post" && (
          <>
            <FeedStatistics referencesFilter={referencesFilter} />

          </>
        )}

        <div className="feed-posts">
          {isLoading && (
            <div className="feed-posts-loader">
              <LoadingOutlined />
            </div>
          )}
          {!isLoading && postCount > 0 && (
            <>
              <div className="flex">
                <div className="grey">
                  Всего постов: {(+postCount).toLocaleString()}
                </div>
              </div>
              <div className="post-list">
                {postList?.slice(0,5)?.map(
                  (
                    item: { id: React.Key | null | undefined },
                    id: React.Key | null | undefined
                  ) => (
                    <div className="flex" key={id}>
                      <Post
                        key={item.id}
                        post={item}
                        changeTonal={changeTonal}
                      />
                    </div>
                  )
                )}
              </div>
            </>
          )}
          {!isLoading && postCount == 0 && (
            <div className="flex">
              <div className="feed-posts__empty">Постов пока нет</div>
            </div>
          )}
        </div>
      </div>
      {checkedPosts.length > 0 && (
        <div className="fixed-block flex-space">
          <div className="flex">
            <a onClick={selectAll} className="flex btn-cursor">
              <IconChecked />
              Выбрать все
            </a>
            <a onClick={() => setCheckedPosts([])} className="flex btn-cursor">
              <IconUndo />
              Сбросить
            </a>
          </div>
          <div className="flex">
            <div className="grey">Постов выбрано: {checkedPosts.length}</div>
            <div className="red-bg red btn-cursor" onClick={deleteAll}>
              <DeleteOutlined />{" "}
              {tab == "post" ? "Исключить" : "Вернуть в ленту"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PostsList;
